<template>
  <div id="header" :class="scroll > 80 ? '_is_top' : ''">
    <!-- <div id="header"> -->
    <div class="_center" v-if="$store.state.screenWidth > 960">
      <div class="_left">
        <div class="_logo" @click="$router.push('/')">
          <img
            v-if="scroll > 80"
            src="https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/logo/p_logo_b.png"
            alt=""
          />
          <img
            v-else
            src="https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/logo/p_logo_b_w.png"
            alt=""
          />
        </div>
      </div>
      <div class="_right">
        <ul class="_nav">
          <li
            class="_item"
            :class="
              scroll > 150 && $store.state.headNav === 'Index' ? '_active' : ''
            "
            @click="$router.push('/')"
          >
            <!-- <a href="#/">首页</a> -->
            <a>首页</a>
          </li>
          <li
            class="_item"
            :class="
              scroll > 150 && $store.state.headNav === 'About' ? '_active' : ''
            "
            @click="$router.push('/about')"
          >
            <!-- <a href="#/about">关于彼盟</a> -->
            <a>关于彼盟</a>
          </li>
          <li
            class="_item"
            :class="
              scroll > 150 && $store.state.headNav === 'Lvp' ? '_active' : ''
            "
            @click="$router.push('/product/lvp')"
          >
            <!-- <a href="#/product/lvp">产品中心</a> -->
            <a>产品中心</a>
          </li>
          <li
            class="_item"
            :class="
              scroll > 150 && $store.state.headNav === 'ProjectShow'
                ? '_active'
                : ''
            "
            @click="$router.push('/project')"
          >
            <!-- <a href="#/project">项目案例</a> -->
            <a>项目案例</a>
          </li>
          <li
            class="_item"
            :class="
              scroll > 150 && $store.state.headNav === 'News' ? '_active' : ''
            "
            @click="$router.push('/news')"
          >
            <!-- <a href="#/news">新闻中心</a> -->
            <a>新闻中心</a>
          </li>
          <li
            class="_item"
            :class="
              scroll > 150 && $store.state.headNav === 'Contact'
                ? '_active'
                : ''
            "
            @click="$router.push('/contact')"
          >
            <!-- <a href="#/contact">联系我们</a> -->
            <a>联系我们</a>
          </li>
        </ul>
        <div class="_phone">
          <!-- 400-0098-709 -->
          <!-- <i class="iconfont icon-dianhua1" style="margin-right: 5px"></i> -->
        </div>
      </div>
    </div>
    <div class="_mobile" v-else-if="$store.state.screenWidth <= 960">
      <van-nav-bar
        right-text="按钮"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
      >
        <template #left>
          <div class="_m_icon"></div>
        </template>
        <template #right>
          <i class="_icon iconfont icon-shouqianniuicon"></i>
        </template>
        <template #title>
          <div style="color: #333; font-weight: bold">
            <i class="iconfont icon-dianhua1"></i>
            <a style="color: #333" href="tel:400-0098-709">400-0098-709</a>
          </div>
        </template>
      </van-nav-bar>
      <van-popup v-model="mobile.show" round position="top">
        <!-- <van-cell title="首页" /> -->
        <van-nav-bar
          right-text="按钮"
          left-arrow
          @click-left="onClickLeft"
          @click-right="onClickRightClose"
        >
          <template #left>
            <div class="_m_icon"></div>
          </template>
          <template #right>
            <i class="_icon iconfont icon-guanbi"></i>
          </template>
          <template #title>
            <div style="color: #333; font-weight: bold">
              <i class="iconfont icon-dianhua1"></i>
              <a style="color: #333" href="tel:400-0098-709">400-0098-709</a>
            </div>
          </template>
        </van-nav-bar>
        <van-collapse v-model="mobile.activeName" accordion>
          <van-cell
            title="首页"
            name="1"
            class="iconfont icon-shouye-shouye"
            icon
            @click="$router.push('/')"
            :class="$store.state.headNav === 'Index' ? '_active' : ''"
          ></van-cell>
          <van-cell
            title="关于彼盟"
            name="1"
            class="iconfont icon-fill_jianjie"
            icon
            @click="$router.push('/about')"
            :class="$store.state.headNav === 'About' ? '_active' : ''"
          ></van-cell>
          <!-- <van-collapse-item name="2">
            <template #title>
              <div>
                <i class="_icon iconfont icon-fill_jianjie"></i>关于彼盟
              </div>
            </template>
            <van-cell @click="$router.push('/about')" title="公司简介" />
            <van-cell @click="$router.push('/about')" title="企业文化" />
            <van-cell @click="$router.push('/about')" title="发展历程" />
            <van-cell @click="$router.push('/about')" title="组织结构" />
            <van-cell @click="$router.push('/about')" title="荣誉展示" />
          </van-collapse-item> -->
          <van-collapse-item name="3">
            <template #title>
              <div style="color: #666">
                <i
                  class="_icon iconfont icon-chanpinguanli"
                  style="margin-right: 0.2rem"
                ></i
                >产品中心
              </div>
            </template>
            <van-cell
              @click="$router.push('/product/lvp')"
              :class="$store.state.newsNav === 'Lvp' ? '_active' : ''"
              title="HBIM LVP"
            />
            <van-cell
              :class="$store.state.newsNav === 'Opm' ? '_active' : ''"
              @click="$router.push('/product/opm')"
              title="HBIM OPM"
            />
          </van-collapse-item>
          <van-cell
            @click="$router.push('/project')"
            title="项目案例"
            name="4"
            class="iconfont icon-a-ziyuan539"
            icon
            :class="$store.state.headNav === 'ProjectShow' ? '_active' : ''"
          ></van-cell>
          <van-cell
            @click="$router.push('/news')"
            title="新闻中心"
            name="6"
            class="iconfont icon-24gf-newspaper2"
            icon
            :class="$store.state.headNav === 'News' ? '_active' : ''"
          ></van-cell>
          <van-collapse-item name="5">
            <template #title>
              <div style="color: #666">
                <i
                  class="_icon iconfont icon-dianhua1"
                  style="margin-right: 0.2rem"
                ></i
                >联系我们
              </div>
            </template>
            <van-cell
              @click="$router.push('/contact')"
              title="合作伙伴"
              :class="$store.state.contactNav === 'Contact' ? '_active' : ''"
            />
            <van-cell
              @click="$router.push('/contact/relation')"
              title="联系我们"
              :class="$store.state.contactNav === 'Relation' ? '_active' : ''"
            />
            <van-cell
              @click="$router.push('/contact/join_us')"
              title="诚聘英才"
              :class="$store.state.contactNav === 'JoinUs' ? '_active' : ''"
            />
          </van-collapse-item>
        </van-collapse>
      </van-popup>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      scroll: 0,
      flag: false,
      scrollTop: "",
      mobile: {
        show: false,
        activeName: "1",
      },
      activeNav: "",
    };
  },
  // 滚动监听
  mounted() {
    window.addEventListener("scroll", this.handleScroll); // 监听页面滚动
    this.scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    this.init();
  },
  methods: {
    init() {
      if (
        this.$store.state.aboutNav === "About" ||
        this.$store.state.aboutNav === "Course" ||
        this.$store.state.aboutNav === "Culture" ||
        this.$store.state.aboutNav === "Organization" ||
        this.$store.state.aboutNav === "Honor"
      ) {
        this.mobile.activeName = "2";
      } else if (
        this.$store.state.newsNav === "News" ||
        this.$store.state.newsNav === "Industry"
      ) {
        this.mobile.activeName = "3";
      } else if (
        this.$store.state.contactNav === "Contact" ||
        this.$store.state.contactNav === "Relation" ||
        this.$store.state.contactNav === "JoinUs"
      ) {
        this.mobile.activeName = "5";
      }
    },
    // 获取页面滚动距离
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.scroll = scrollTop;
    },
    onClickLeft() {
      this.$router.push({
        name: "Index",
      });
    },
    onClickRight() {
      this.mobile.show = true;
    },
    onClickRightClose() {
      this.mobile.show = false;
    },
  },
  // 滚动重置
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
#header {
  width: 100%;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  color: #fff;
  transition: background 0.5s ease 0s;
  display: flex;
  overflow: hidden;

  &._is_top {
    background: #fff;
    color: #333;
    box-shadow: 0.02rem 0.04rem 0.04rem #ccc;
    z-index: 999;
    ._item {
      a {
        color: #333 !important;
      }
      &:hover a {
        color: #3660aa !important;
      }
    }
  }
  ._center {
    height: 0.7rem;
    display: flex;
    justify-content: space-between;
    height: 100%;
    ._left {
      width: 2.83rem;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      ._logo {
        height: 0.51rem;
        line-height: 0.6rem;
        cursor: pointer;
        img {
          vertical-align: bottom;
          width: 100%;
          height: 100%;
        }
      }
    }
    ._right {
      position: relative;
      ._nav {
        display: flex;
        ._item {
          line-height: 0.7rem;
          padding: 0 0.3rem;
          font-size: 0.18rem;
          cursor: pointer;
          a {
            color: #fff;
          }
          &:hover a {
            color: #3660aa;
          }
        }
        ._active {
          font-size: 0.18rem;
          position: relative;
          background-color: #e9f0f8;
          a {
            color: #333;
          }
          &::before {
            position: absolute;
            top: 0;
            left: 0;
            content: "";
            width: 100%;
            height: 0.02rem;
            background: #3660aa;
          }
        }
      }

      ._phone {
        position: absolute;
        top: 0;
        right: -2rem;
        width: 1.9rem;
        height: 0.48rem;
        line-height: 0.48rem;
        text-align: center;
        font-weight: bold;
        background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/right_tel.png")
          no-repeat;
        // background-image: linear-gradient(0deg, #fe6022 0%, #f97d31 100%),
        //   linear-gradient(#000000, #000000);
        // background-blend-mode: normal, normal;
        background-size: cover;
        border-radius: 0rem 0rem 0.1rem 0.1rem;
        text-shadow: 0rem 0.01rem 0.01rem;
        font-size: 0.18rem;
        i {
          font-size: 0.18rem;
        }
        color: #fff;
      }
    }
  }
  ._mobile {
    width: 100%;
    height: 1rem;
    // /deep/ .van-overlay {
    //   background-color: transparent !important;
    // }
    .van-nav-bar {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      ._m_icon {
        width: 0.975rem;
        height: 0.5rem;
        background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/logo.png")
          no-repeat;
        background-size: contain;
        background-position: center;
      }
      ._icon {
        font-size: 0.22rem;
        color: #666;
      }
    }
    ._active {
      color: #3660aa !important;
    }
    .van-cell {
      color: #666;
    }
    ._icon {
      color: #666;
    }
    .van-cell__title {
      padding-left: 0.2rem;
    }
    .van-popup--top {
      // top: 0.7rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue